import React, { FC, useState } from "react";
import { InputSelect, InputText } from "../../../../components/input";
import { IInputArrayFormProps, IInputArrayDataStructureItem } from "../../../../components/input/arrayData";
import { CreateNotification } from "../../../../components/notifier";
import { Button } from "../../../../modules/button";
import { InputWraper, useForm } from "../../../../modules/form";
import { ObjectUtils } from "../../../../modules/utils";
import {
  convertToDate,
  getDDMMYYYFormat,
} from "../../../../helper/dateTimeHelper";
import { InputDateRangePicker } from "../../../../components/input/date-range-picker";
import BusinessFormComponent from "../../../../modules/form/businessForm";

export const BusinessTicketContentStructure: IInputArrayDataStructureItem[] = [
  {
    name: "Name",
    label: "Họ và tên (Tiếng Việt có dấu)",
    isVisibleOnList: true,
  },
  {
    name: "Position",
    label: "Chức vụ",
    isVisibleOnList: true,
  },
  {
    name: "Class",
    label: "Hạng ghế",
    isVisibleOnList: true,
  },
  {
    name: "TickNumber",
    label: "Số vé (Trường hợp hoàn vé)",
    isVisibleOnList: true,
  },
  {
    name: "TripBusiness",
    label: `Hành trình (VD: Nơi đi: SGN, Nơi đến: DAD, Ngày: 19/09/2023 02:45CH)`,
    isVisibleOnList: true,
    defaultValue: [],
  },
  // {
  //   name: "FlightAway",
  //   label: "Chuyến bay đi / giờ / ngày",
  //   isVisibleOnList: true,
  // },
  // {
  //   name: "ReturnFlight",
  //   label: "Chuyến bay về / giờ / ngày",
  //   isVisibleOnList: true,
  // },
];

export const BusinessTicketContentForm: FC<IInputArrayFormProps> = (props) => {
  const { childFormData } = props;
  const TypeClass = ["J", "M-PR4", "M", "ECONOMY"];
  const [typeClassSelected, setTypeClassSelected] = useState(null as any);

  const { handleSubmit, getInputProps } = useForm({
    structure: props.structure.map((item) => {
      return {
        ...item,
        defaultValue: ObjectUtils.getIn(childFormData, item.name) || item.defaultValue,
      };
    }),
    onSubmit: (values) => {
      values.Class = typeClassSelected ? typeClassSelected : values.Class;
      if (values.TripBusiness.length > 0) {
        const trip = [...values.TripBusiness];
        let count = 0;
        trip.forEach((e: any) => {
          if (!e.from || !e.to) count++;
        });
        if (count > 0) {
          CreateNotification({
            title: "Thông báo",
            body: "Vui lòng nhập đầy đủ thông tin hành trình!",
            icon: "/icons/warning.png",
          });
          return;
        }
      }
      if (
        !values.Name ||
        !values.Position ||
        (!values.Class && !props.isOnlyPassport) ||
        (!values.TickNumber && props.isRefund)
      ) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
        return;
      }
      if (values.TripBusiness.length < 2) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập ít nhất 2 chặng (cả chặng đi và chặng về) !",
          icon: "/icons/warning.png",
        });
        return;
      } else props.onSubmit(values);
    },
  });

  const onTypeVehicleChange = (e: any) => {
    setTypeClassSelected(e.value);
  };

  return (
    <div className="Form__add-demandForSupplies py-3">
      <h6>
        ( <span className="star_content">*</span> ): Trường thông tin bắt buộc phải nhập{" "}
      </h6>

      <InputWraper inputProps={getInputProps("Name")} renderInput={(s) => <InputText {...s} />} isRequired />
      <InputWraper inputProps={getInputProps("Position")} renderInput={(s) => <InputText {...s} />} isRequired />
      <InputWraper
        inputProps={getInputProps("Class")}
        renderInput={(s) => (
          <InputSelect
            {...s}
            options={TypeClass.map((e: any) => ({
              label: e,
              value: e,
            }))}
            onChange={onTypeVehicleChange}
            value={typeClassSelected ? typeClassSelected : s.value}
            placeholder="* Vui lòng chọn hạng ghế"
          />
        )}
        isRequired={!props.isOnlyPassport}
      />
      <InputWraper
        inputProps={getInputProps("TickNumber")}
        renderInput={(s) => <InputText {...s} />}
        isRequired={props.isRefund}
      />
      <InputWraper
        inputProps={getInputProps("TripBusiness")}
        renderInput={(s) => <BusinessFormComponent {...s} />}
        isRequired
      />
      <div className="foot">
        <Button type="button" label="Xác nhận" onClick={handleSubmit} />
      </div>
    </div>
  );
};

export const PassportContentStructure: IInputArrayDataStructureItem[] = [
  {
    name: "PassportForPerson",
    label: "Cấp giấy cho ông bà",
    isVisibleOnList: true,
  },
  {
    name: "Position",
    label: "Chức vụ",
    isVisibleOnList: true,
  },
  {
    name: "Unit",
    label: "Đơn vị",
    isVisibleOnList: true,
  },
  {
    name: "SendOnForBusiness",
    label: "Được cử đi công tác",
    isVisibleOnList: true,
  },
  {
    name: "BusinessTime",
    label: "Thời gian đi công tác",
    isVisibleOnList: true,
  },
  {
    name: "TripBusiness",
    label: "Nơi đi - Nơi đến",
    isVisibleOnList: true,
    defaultValue: [],
  },
  {
    name: "Class",
    label: "Hạng vé",
    isVisibleOnList: true,
  },
  // {
  //   name: "BusinessUnit",
  //   label: "Đơn vị công tác",
  //   isVisibleOnList: true,
  // },
  {
    name: "BusinessContent",
    label: "Nội dung công tác",
    isVisibleOnList: true,
  },
  {
    name: "ConfirmBusinessUnit",
    label: "Xác nhận của đơn vị công tác (Ký tên, đóng dấu)",
    isVisibleOnList: true,
  },
  {
    name: "ConfirmPersonBusiness",
    label: "Xác nhận của CB-NV sử dụng xe",
    isVisibleOnList: true,
  },
];

export const PassportContentForm: FC<IInputArrayFormProps> = (props) => {
  const { childFormData } = props;
  const today = new Date();
  const [originDate, destinationDate] = childFormData.BusinessTime.replace(" ", "").split("-");
  const [estimatedTimeOfUse, setEstimatedTimeOfUse] = useState([
    originDate ? new Date(convertToDate(originDate.trim())) : new Date(),
    destinationDate ? convertToDate(destinationDate.trim()) : new Date(),
  ]);
  const TypeClass = ["J", "M-PR4", "M", "ECONOMY"];
  const [typeClassSelected, setTypeClassSelected] = useState(null as any);

  const { handleSubmit, getInputProps } = useForm({
    structure: props.structure.map((item) => {
      return {
        ...item,
        defaultValue: ObjectUtils.getIn(childFormData, item.name) || item.defaultValue,
      };
    }),
    onSubmit: (values) => {
      values.BusinessTime = estimatedTimeOfUse
        ? getDDMMYYYFormat(estimatedTimeOfUse[0]) + "-" + getDDMMYYYFormat(estimatedTimeOfUse[1])
        : values.BusinessTime;
      values.Class = typeClassSelected ? typeClassSelected : values.Class;
      if (
        !values.PassportForPerson ||
        !values.Position ||
        !values.Unit ||
        !values.SendOnForBusiness ||
        !values.BusinessTime ||
        !values.TripBusiness ||
        !values.Class ||
        //  !values.BusinessUnit ||
        !values.BusinessContent
        //  !values.ConfirmPersonBusiness ||
        //  !values.ConfirmBusinessUnit
      ) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
        return;
      }
      props.onSubmit(values);
    },
  });

  const onTypeVehicleChange = (e: any) => {
    setTypeClassSelected(e.value);
  };

  return (
    <div className="Form__add-new py-3">
      <h6>
        ( <span className="star_content">*</span> ): Trường thông tin bắt buộc phải nhập{" "}
      </h6>

      <InputWraper
        inputProps={getInputProps("PassportForPerson")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />
      <InputWraper inputProps={getInputProps("Position")} renderInput={(s) => <InputText {...s} />} isRequired />
      <InputWraper inputProps={getInputProps("Unit")} renderInput={(s) => <InputText {...s} />} isRequired />
      <InputWraper inputProps={getInputProps("SendOnForBusiness")} renderInput={(s) => <InputText {...s} />} />
      <InputWraper
        inputProps={getInputProps("BusinessTime")}
        renderInput={(s) => (
          <InputDateRangePicker {...s} value={estimatedTimeOfUse} onChange={setEstimatedTimeOfUse} minDate={today} />
        )}
        isRequired
      />
      <InputWraper
        inputProps={getInputProps("TripBusiness")}
        renderInput={(s) => <BusinessFormComponent {...s} isPassport={true} />}
      />
      <InputWraper
        inputProps={getInputProps("Class")}
        renderInput={(s) => (
          <InputSelect
            {...s}
            options={TypeClass.map((e: any) => ({
              label: e,
              value: e,
            }))}
            onChange={onTypeVehicleChange}
            value={typeClassSelected ? typeClassSelected : s.value}
            placeholder="* Vui lòng chọn hạng ghế"
          />
        )}
        isRequired
      />
      {/* <InputWraper
        inputProps={getInputProps("BusinessUnit")}
        renderInput={(s) => <InputText {...s} />}
      /> */}
      <InputWraper inputProps={getInputProps("BusinessContent")} renderInput={(s) => <InputText {...s} />} />
      <InputWraper
        inputProps={getInputProps("ConfirmBusinessUnit")}
        renderInput={(s) => <InputText {...s} isDisabled={true} />}
      />
      <InputWraper
        inputProps={getInputProps("ConfirmPersonBusiness")}
        renderInput={(s) => <InputText {...s} isDisabled={true} />}
      />
      <div className="foot">
        <Button type="button" label="Xác nhận" onClick={handleSubmit} />
      </div>
    </div>
  );
};
